import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BookingProvider } from './context/BookingContext';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SearchResultsPage from './pages/SearchResultsPage';
import PassengerDetailsPage from './pages/PassengerDetailsPage';
import PaymentPage from './pages/PaymentPage';
import SeatSelectionPage from './pages/SeatSelectionPage';
import InfoPage from './pages/InfoPage';
import AccountPage from './pages/AccountPage';
import RoutesPage from './pages/RoutesPage';
import SuperiorPage from './pages/SuperiorPage';
import DestinationPage from './pages/DestinationPage';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <AuthProvider>
    <LanguageProvider>
    <BookingProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<SearchResultsPage />} />
              <Route path="/seats" element={<SeatSelectionPage />} />
              <Route path="/passenger" element={<PassengerDetailsPage />} />
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/destination/:cityId" element={<DestinationPage />} />
              <Route path="/info/superior" element={<SuperiorPage />} />
              <Route path="/info/routes" element={<RoutesPage />} />
              <Route path="/info/:slug" element={<InfoPage />} />
              <Route path="/account" element={<AccountPage />} />
            </Routes>
          </main>
          <Footer />
          <CookieConsent />
        </div>
      </BrowserRouter>
    </BookingProvider>
    </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
